export const LAST_WORKSPACE_ID = 'lastWorkspaceId';
export const WORKSPACE_GRAPHIQL = 'workspaceGraphiql';
export const SELECTED_COLUMNS = 'selectedColumns';
export const META_FIELDS = 'metaFieldsExpanded';
export const ENVIRONMENT = 'environment';
